import { TIERS, TIER_RULES } from "../services/constants";

// FAQ + tier rules + disclaimer page. Single scrollable doc with anchor IDs
// so the footer links jump straight to the relevant section.
export default function About() {
  return (
    <div className="container" style={{ maxWidth: 780, paddingBottom: 80 }}>
      <h1 style={{ fontSize: 28, fontWeight: 800, marginTop: 8 }}>About Pop Market</h1>

      <p className="muted">
        Pop Market is PlayAware's open directory for BGMI and PUBG Mobile
        popularity sellers. Browse verified vendors by region, stock segment,
        rate, and reputation. Contact them through their preferred channel.
        We don't process transactions — we just make the buyer-seller match
        searchable instead of buried in WhatsApp.
      </p>

      <h2 style={{ marginTop: 32 }}>How tiers work</h2>
      <p className="muted">
        Tiers are an internal PlayAware reputation marker. They unlock as a
        seller accumulates verified profile signals + community reviews. They
        can&apos;t be bought.
      </p>
      <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 16 }}>
        {TIERS.slice(1).map((t) => {
          const r = TIER_RULES[t.key] || {};
          return (
            <div key={t.key} className="card" style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
              <span className={`tier-badge ${t.cssClass}`} style={{ marginTop: 2 }}>{t.label}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 600 }}>{r.notes || "—"}</div>
                {!r.manualOnly && (
                  <div className="dim" style={{ fontSize: 11, marginTop: 4 }}>
                    Requires {r.minReviews}+ reviews · ≥{r.minRating} avg ·
                    {" "}{r.minDays}+ days tenure
                    {r.minReserveTier !== "none" && ` · proven ≥${r.minReserveTier} reserves`}
                  </div>
                )}
                {r.manualOnly && (
                  <div className="dim" style={{ fontSize: 11, marginTop: 4 }}>
                    Hand-picked by the PlayAware team
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <h2 id="disclaimer" style={{ marginTop: 32 }}>Disclaimer</h2>
      <div className="card" style={{ fontSize: 13, lineHeight: 1.6 }}>
        <p style={{ marginTop: 0 }}>
          PlayAware is a directory and reputation platform. We do not process
          payments, hold funds in escrow, or mediate disputes between buyers
          and sellers. All transactions happen off-platform via the channels
          sellers list on their profile.
        </p>
        <p>
          Users are solely responsible for compliance with their game's terms
          of service. Verifying a seller's identity, reserves, and reputation
          before transacting is your responsibility.
        </p>
        <p style={{ marginBottom: 0 }}>
          PlayAware is not affiliated with Krafton, Tencent, or any game
          publisher. BGMI and PUBG Mobile are trademarks of their respective
          owners.
        </p>
      </div>

      <h2 id="privacy" style={{ marginTop: 32 }}>Privacy</h2>
      <p className="muted" style={{ fontSize: 13 }}>
        See the main PlayAware privacy policy at{" "}
        <a href="https://playaware.com/privacy">playaware.com/privacy</a>.
      </p>

      <h2 id="terms" style={{ marginTop: 32 }}>Terms</h2>
      <p className="muted" style={{ fontSize: 13 }}>
        Use of Pop Market is governed by the main PlayAware terms at{" "}
        <a href="https://playaware.com/terms">playaware.com/terms</a>.
      </p>
    </div>
  );
}
